import React from "react";
import LandingPage from "../components/landing/LandingPage.jsx";

import { Feature_collections } from "../components/component";
import Benifits from "../components/dao/Benifits";
import NewseLatter2 from "../components/dao/newseLatter2";
import Hero_11 from "../components/hero/hero_11";
import CollabHub from "../components/home/collabHub";
import WhatWeDo from "../components/home/WhatWeDo";
import HowItWorks from "../components/home/HowItWorks";
import WeeklyDigest from "../components/home/WeeklyDigest";

const Home = () => {
  return (
    <main>
      <Hero_11 />
      <WhatWeDo />
      <HowItWorks />
      <Feature_collections />
      <NewseLatter2 bgWhite={false} />
      <Benifits />
      <CollabHub />
      <WeeklyDigest />
    </main>
  );
};

export default Home;
